<template>
<div class="employee_info">
      <ob-modal2 :show.sync="employerPopup" width="900px" :backdrop="false" id="scrollable-container1">
        <template slot="modal-title">
            <div class="modal-head">
                <h4 class="modal-title" v-if="isupdate">
                   {{ isupdate ? 'Update Employer Information (Section 3 & 4)' : 'Initiate Employer Information (Section 3 & 4)' }}
                </h4>
                <h4 class="modal-title" v-else>
                    {{ 'Complete Employer Information (Section 3 & 4)' }}
                    </h4>
            </div>
        </template>

    <template slot="modal-body">
         <div>
             <p class="title-content">
                   Please fill the below details, which will be updated in the Employer section of Form I-983.
                </p>
            </div>
        <div class="row" style="margin-top:10px;">
            <div class="col-md-12">
                <div class="col-md-8">
                    <div class="form-group">
                        <label>Employer Name</label><span class="validation-star">*</span>
                        <ob-input v-formi9-name v-model.trim="EmployerDetails.Name" placeholder="Enter Employer Name" :class="{ 'ob-vuelidate_input-error': $v.EmployerDetails.Name.$error }" @input="updateValue(EmployerDetails.Name)"></ob-input>
                        <span class="ob-vuelidate_error-msg" v-if="$v.EmployerDetails.Name.$dirty && !$v.EmployerDetails.Name.required"> Enter Employer Name</span>
                   </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Employer Website URL</label><span class="validation-star">*</span><span v-on:mouseover="mouseOver = '1'"
                                    v-on:mouseout="mouseOver= ''" ><img v-bind:src="mouseOver === '1' ? `${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/information_blue.svg` : `${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/information_grey.svg`" class="img_design" v-tooltip='"Ex: http://www.example.com."'/></span>
                        <ob-input v-model.trim="EmployerDetails.Website" placeholder="Enter Employer Website" :class="{ 'ob-vuelidate_input-error': $v.EmployerDetails.Website.$error }"></ob-input>
                        <span class="ob-vuelidate_error-msg" v-if="$v.EmployerDetails.Website.$dirty && !$v.EmployerDetails.Website.required"> Enter Employer Website</span>
                        <span class="ob-vuelidate_error-msg" v-if="$v.EmployerDetails.Website.$dirty && !$v.EmployerDetails.Website.url"> Enter valid Employer Website</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Employer Address</label><span class="validation-star">*</span>
                        <ob-input v-model.trim="EmployerDetails.EmployerAddress.Address" placeholder="Enter Employer Address" :class="{ 'ob-vuelidate_input-error': $v.EmployerDetails.EmployerAddress.Address.$error }"></ob-input>
                        <span class="ob-vuelidate_error-msg" v-if="$v.EmployerDetails.EmployerAddress.Address.$dirty && !$v.EmployerDetails.EmployerAddress.Address.required"> Enter Employer Address</span>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Suite </label><span class="validation-star">*</span>
                        <ob-input v-model.trim="EmployerDetails.EmployerAddress.Suite" placeholder="Enter Suite" :class="{ 'ob-vuelidate_input-error': $v.EmployerDetails.EmployerAddress.Suite.$error }"></ob-input>
                        <span class="ob-vuelidate_error-msg" v-if="$v.EmployerDetails.EmployerAddress.Suite.$dirty && !$v.EmployerDetails.EmployerAddress.Suite.required"> Enter Suite</span>
                    </div>
               </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label>City, State</label><span class="validation-star">*</span>
                         <location-search :inModal="true" v-model.trim="EmployerDetails.EmployerAddress.Location" :vmodelData.sync="EmployerDetails.EmployerAddress.Location" @input="getZipCode()" :class="{ 'ob-vuelidate_input-error': $v.EmployerDetails.EmployerAddress.Location.$error }" ></location-search>
                          <span class="ob-vuelidate_error-msg" v-if="$v.EmployerDetails.EmployerAddress.Location.$dirty && !$v.EmployerDetails.EmployerAddress.Location.required"> Enter Location</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="col-md-4">
                    <div class="form-group">
                        <label>ZIP Code</label><span class="validation-star">*</span>
                        <ob-input v-model.trim="EmployerDetails.EmployerAddress.ZipCode" placeholder="Enter ZIP Code" v-number-only :maxLength="9" :class="{ 'ob-vuelidate_input-error': $v.EmployerDetails.EmployerAddress.ZipCode.$error }"></ob-input>
                         <span class="ob-vuelidate_error-msg" v-if="$v.EmployerDetails.EmployerAddress.ZipCode.$dirty && !$v.EmployerDetails.EmployerAddress.ZipCode.required"> Enter zip code</span>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Employer ID Number (EIN)</label><span class="validation-star">*</span>
                        <ob-input v-model.trim="EmployerDetails.EmployerIDNumber" placeholder="Enter Employer ID Number" :class="{ 'ob-vuelidate_input-error': $v.EmployerDetails.EmployerIDNumber.$error }"></ob-input>
                         <span class="ob-vuelidate_error-msg" v-if="$v.EmployerDetails.EmployerIDNumber.$dirty && !$v.EmployerDetails.EmployerIDNumber.required"> Enter Employer ID Number</span>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Number of Full-Time Employees in U.S.</label><span class="validation-star">*</span>
                        <ob-input v-model.trim="EmployerDetails.FullTimeEmployees" placeholder="Enter Number of Full-Time Employees" v-number-only :maxLength="10" :class="{ 'ob-vuelidate_input-error': $v.EmployerDetails.FullTimeEmployees.$error }"></ob-input>
                         <span class="ob-vuelidate_error-msg" v-if="$v.EmployerDetails.FullTimeEmployees.$dirty && !$v.EmployerDetails.FullTimeEmployees.required"> Enter Number of Full-Time Employees</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="col-md-8">
                    <div class="form-group">
                        <label>North American Industry Classification System (NAICS) Code</label><span class="validation-star">*</span><span v-on:mouseover="onShowmouseOver = true"
                                    v-on:mouseout="onShowmouseOver = false" >
                            <ob-popover  trigger="hover" :options="{placement: 'bottom'}" ref="popover">
                                <div class="popper">
                                   <span style="font-size: 12.5px;">Enter the company’s NAICS code. (Federal statistical agencies use the NAICS code to classify business establishments for
                                    the purpose of collecting, analyzing and publishing statistical data related to the U.S.
                                    business economy.)  NAICS codes are accessible at </span><span style="font-size: 12.5px;"> <a href="https://www.census.gov/cgi‐bin/sssd/naics/naicsrch?chart=2017." target="_blank" >https://www.census.gov/cgi‐bin/sssd/naics/naicsrch?chart=2017</a> </span>
                                </div>
                                <div slot="reference" style="display: inline-block;">
                                    <img v-bind:src="onShowmouseOver === true ? `${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/information_blue.svg` : `${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/information_grey.svg`" class="img_design"/>
                                </div>
                            </ob-popover>
                            </span>
                        <ob-input v-model.trim="EmployerDetails.NAICSCode" placeholder="Enter NAICS Code" v-number-only :maxLength="6" :class="{ 'ob-vuelidate_input-error': $v.EmployerDetails.NAICSCode.$error }"></ob-input>
                         <span class="ob-vuelidate_error-msg" v-if="$v.EmployerDetails.NAICSCode.$dirty && !$v.EmployerDetails.NAICSCode.required"> Enter NAICS Code</span>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label>OPT Hours Per Week </label><span class="validation-star">*</span><span v-on:mouseover="mouseOver = '2'"
                                    v-on:mouseout="mouseOver= ''" ><img v-bind:src="mouseOver === '2' ? `${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/information_blue.svg` : `${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/information_grey.svg`" class="img_design" v-tooltip='"Enter a number from 20 to 40, or a range using hyphen only (e.g. 20 - 40, 25 - 35)."'/></span>
                        <ob-input v-model.trim="EmployerDetails.OPTHoursPerWeek" placeholder="e.g. 25 or 20 - 40" :maxLength="15" :class="{ 'ob-vuelidate_input-error': $v.EmployerDetails.OPTHoursPerWeek.$error }"></ob-input>
                         <span class="ob-vuelidate_error-msg" v-if="$v.EmployerDetails.OPTHoursPerWeek.$dirty && !$v.EmployerDetails.OPTHoursPerWeek.required"> Enter OPT Hours Per Week</span>
                           <span class="ob-vuelidate_error-msg" v-if="$v.EmployerDetails.OPTHoursPerWeek.$dirty && $v.EmployerDetails.OPTHoursPerWeek.required && !$v.EmployerDetails.OPTHoursPerWeek.validOPTHoursPerWeek">Enter 20-40 hours/week, or a range with hyphen only (e.g. 20 - 40).</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Salary Amount</label><span class="validation-star">*</span>
                        <ob-input icon="fa-usd" placeholder="Salary Amount" v-decimal-numbers v-model.trim="EmployerDetails.Salary" :class="{ 'ob-vuelidate_input-error': $v.EmployerDetails.Salary.$error }"></ob-input>
                         <span class="ob-vuelidate_error-msg" v-if="$v.EmployerDetails.Salary.$dirty && !$v.EmployerDetails.Salary.required"> Enter Salary Amount</span>
                         <span class="ob-vuelidate_error-msg" v-if="$v.EmployerDetails.Salary.$dirty && !$v.EmployerDetails.Salary.minValue">Must be greater than 0.</span>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Salary Frequency</label><span class="validation-star">*</span>
                        <ob-select2 :inModal="true" :options="salary" v-model.trim="EmployerDetails.SalaryType" :class="{ 'ob-vuelidate_input-error': $v.EmployerDetails.SalaryType.$error }"></ob-select2>
                         <span class="ob-vuelidate_error-msg" v-if="$v.EmployerDetails.SalaryType.$dirty && !$v.EmployerDetails.SalaryType.required"> Select Salary Frequency</span>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                <label>Employment/Contract Start Date</label><span class="validation-star">*</span>
					<ob-date-time-picker id="esd" :options="options3" :inputvalue="EmployerDetails.EmploymentStartDate" v-model.trim="EmployerDetails.EmploymentStartDate" @updated="(v) => this.EmployerDetails.EmploymentStartDate = v" :class="{ 'ob-vuelidate_input-error': $v.EmployerDetails.EmploymentStartDate.$error }"></ob-date-time-picker>
                     <span class="ob-vuelidate_error-msg" v-if="$v.EmployerDetails.EmploymentStartDate.$dirty && !$v.EmployerDetails.EmploymentStartDate.required"> Enter Employment Start Date</span>
                   </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="col-md-8">
                    <div class="form-group">
                         <div class="col-md-12" style="padding-left: 0px;padding-bottom: 5px">
                        <label>Other Compensation (Type and Estimated Amount or Value)</label>
                         </div>
                         <div class="col-md-1">
                             1.
                         </div>
                          <div class="col-md-11" style="padding: 0px; margin-bottom: 15px">
                              <ob-input  v-model.trim="OtherCompensation1"></ob-input>
                         </div>
                    </div>
                </div>
                <div class="col-md-8">
                    <div class="form-group">
                         <div class="col-md-1">
                              2.
                         </div>
                          <div class="col-md-11" style="padding: 0px; margin-bottom: 15px">
                               <ob-input v-model.trim="OtherCompensation2"></ob-input>
                         </div>
                    </div>
                </div>
                <div class="col-md-8">
                    <div class="form-group">
                         <div class="col-md-1">
                              3.
                         </div>
                          <div class="col-md-11" style="padding: 0px; margin-bottom: 15px">
                              <ob-input  v-model.trim="OtherCompensation3"></ob-input>
                         </div>
                     </div>
                </div>
                <div class="col-md-8">
                    <div class="form-group">
                         <div class="col-md-1">
                             4.
                         </div>
                          <div class="col-md-11" style="padding: 0px; margin-bottom: 15px">
                               <ob-input  v-model.trim="OtherCompensation4"></ob-input>
                         </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="content.SignatureType == 'Electronic' && content.Employer.SectionStatus == 'Completed' && this.loggedInUserObj.email != this.clonedContent.Employer.SignatoryAuthority.Email">
            <div class="col-md-12">
                <label style="max-width:50%; padding-left: 32px;">Signature of Employer Official with Signatory Authority </label>
                <div class="form-group" style=" padding-left: 32px;">

                    <div class="custom-sign-div custom-sign-div_inline_style1">
                        <img :src="SignatureDetails.SignatureURL" :class="{'sign-width': this.SignatureDetails.isDraw, 'add-sign-width': !this.SignatureDetails.isDraw}" alt="Uploaded Signature Url" width="250px" height="100px" style="margin-left: -20px;object-fit: contain;">
                </div>
                </div>
            </div>
        </div>
        <div class="row" style="margin-top:10px;" v-if="content.SignatureType == 'Electronic'  && ShowSignaturePad">
            <div class="form-label" style="max-width:50%; padding-left: 32px;">
                <label class="label_title">
                    Signature of Employer Official with Signatory Authority<span class="validation-star">*</span>
                </label>
                <ob-signature-pad :key="counter" v-if="SignatureDetails.EnableSignature" @SaveSignature="saveSignature" @scrollToTop="scrollToTop" :istrainingpopup="true" style="margin-top: 30px; padding-left: 0; text-align: left; width: 0px;"></ob-signature-pad>
                <div v-else class="full-width" style="padding-left:0;display: flex;">
                    <div class="custom-sign-div custom-sign-div_inline_style1">
                        <img :src="SignatureDetails.SignatureURL" :class="{'sign-width': this.SignatureDetails.isDraw, 'add-sign-width': !this.SignatureDetails.isDraw}" alt="Uploaded Signature Url" width="250px" height="100px" style="margin-left: -20px;object-fit: contain;">
                    </div>
                    <div  v-if="this.loggedInUserObj.email == this.clonedContent.Employer.SignatoryAuthority.Email" class="custom-sign-div_inline_style2" style="margin-left: 8px;">
                        <img @click="editSignatureMethod(SignatureDetails.image, true)" :src="`${CDNIMAGESBASEURL}/web/Content/Images/ic_edit.svg`" alt="edit" class="edit-sign-icon"><br />
                        <img @click="deleteSiganture(SignatureDetails.image)" :src="`${CDNIMAGESBASEURL}/web/Content/Images/ic_delete.svg`" alt="delete" class="delete-sign-icon">
                    </div>
                    <ob-edit-signature-pad @SaveSignatureEdit="SignatureEdit"   :istrainingpopup="true" :editSignature.sync="openEditsignature" :fileName="'HRSign'" :tabType="SignatureDetails.tabType" :data="SignatureDetails.uploadData" :drawImageProp="SignatureDetails.drawImage" :isDraw="SignatureDetails.isDraw" :metaInformation="SignatureDetails.metaInformation" @scrollToTop="scrollToTop"></ob-edit-signature-pad> 
                </div>
            </div>
        </div>
        <div class="col-md-12" v-if="content.SignatureType == 'Electronic'  && ShowSignaturePad">
            <span class="ob-vuelidate_error-msg" v-if="(SignatureDetails.Base64Url == '' || SignatureDetails.Base64Url == null) && isshowValidSign">Please enter signature</span>
        </div>
    </template>

    <template slot="modal-footer" class="modal-footer">
                <button type="button" class="btn btn-secondary" @click="employerPopup = false">Cancel</button>
                <button type="button" class="btn btn-primary" @click="onPreview">{{ isupdate ? 'Update' : 'Preview Form' }}</button>
            </template>
  </ob-modal2>
  
  </div>
</template>
<script>
import namevalidation from "Vue/Core/namevalidation.js"
import { required, minLength, maxLength, requiredIf, email, alpha, minValue, url } from 'vuelidate/lib/validators'
    import { req, withParams } from 'vuelidate/lib/validators/common'
      const DecimalNumber = withParams({ type: 'DecimalNumber' }, value => {
        return !req(value) || /^\d+(\.\d{1,2})?$/.test(value);
    })
     const alphawithspace = (value) => {
     var alsp = /^[a-zA-Z\s]*$/i
     return alsp.test(value)
   }
    const letterCount = withParams({ type: 'letterCount' }, value => {
        if (value !=null && value.length <= 150) {
            var strArr = value.split(" ");
            let error = true;
            strArr.forEach(function (word) {
                if (word.length > 100) {
                    error = false
                    return;
                }
            });
            return !req(value) || error
        }
        else {
            return true
        }

    })
    const validOPTHoursPerWeek = (value) => {
        if (!req(value)) {
            return true
        }
        const s = String(value).trim()
        if (s === '') {
            return true
        }
        if (/^\d+$/.test(s)) {
            const n = parseInt(s, 10)
            return n >= 20 && n <= 40
        }
        if (/^\d+\s*-\s*\d+$/.test(s)) {
            const parts = s.split('-')
            const low = parseInt(parts[0].trim(), 10)
            const high = parseInt(parts[1].trim(), 10)
            if (Number.isNaN(low) || Number.isNaN(high)) {
                return false
            }
            if (low < 20 || low > 40 || high < 20 || high > 40) {
                return false
            }
            return low <= high
        }
        return false
    }
export default {
     props :["show", "content", "isupdate"],
    data() {
        return {
            isshowValidSign:false,
            showEditSignature:false,
            ShowSignaturePad:true,
            counter:0,
            openEditsignature:false,
            onShowmouseOver:false,
            mouseOver:'',
            EmployerObject:'',
            clonedContent: null,
            employerPopup : false,
            showSignatoryauthorityList:false,
            selectedSignatoryAuthorityEmail:'',
            EmployerDetails:
            {
                Name:'',
                Website:'',
                EmployerAddress:
                    {
                       Address:'',
                       Location:'',
                       City :'',
                       State :'',
                       Suite :'',
                       ZipCode:''
                    },
                EmployerIDNumber :'',
                FullTimeEmployees :'',
                NAICSCode:'',
                OPTHoursPerWeek:'',
                Salary:'',
                SalaryType:'',
                EmploymentStartDate:'',
                Signatoryauthority : {
                    Name: '',
                    Email:'',
                    Title:''
                },
                OtherCompensations:[],
            },
            SignatureDetails:{
                SignedDate: moment(new Date()).format("MM/DD/YYYY"),
                SignatureURL: '',
                EnableSignature : true,
                IsNewSignature : true,
                IsAllowEdit: true,
                uploadData : "",
                image : "",
                tabType : "",
                drawImage : "",
                editUpload: false,
                isDraw: false,
                Base64Url:'',
                metaInformation: {}
            },
            SignatureDetails: {
                SignatureURL:''
            },
            salary: {
                data: [{
                    "id": "Hourly",
                    "text": "Hourly"
                }, {
                    "id": "Weekly",
                    "text": "Weekly"
                }, {
                    "id": "BiWeekly",
                    "text": "Bi-Weekly"
                }, {
                    "id": "Monthly",
                    "text": "Monthly"
                }, {
                    "id": "SemiMonthly",
                    "text": "Semi-Monthly"
                }, {
                    "id": "Yearly",
                    "text": "Yearly"
                }, ],
                placeholder: "Select Salary Frequency"
            },
            signatoryauthorityList: {
                placeholder: {
                    id: "-1",
                    text: "Select Signatory Authority"
                },
                data: []
            },
           options3: {
                format: 'MM/DD/YYYY',
                ignoreReadonly: true,
                widgetPositioning: {
                    horizontal: "auto",
                    vertical: "bottom"
                }
            },
             OtherCompensation1:'',
             OtherCompensation2:'',
             OtherCompensation3:'',
             OtherCompensation4:'',
        }
    },

     watch: {
        show(val) {
            this.employerPopup = val;
            if(val) { // On Modal Open
                this.clonedContent = this.content;
                this.getSignatoryauthorityList();
                 
                this.copyFromStore();
                if(!this.isupdate)
                {
                     this.getCurrentOrganizationDetails();
                }
            }
        },
        employerPopup(val) {
            this.$emit('update:show', val)
        },
        selectedSignatoryAuthorityEmail(v) {
            this.onChangeSignatoryAuthority(v);
        }
     },
     created()
     {
         this.employerPopup = this.show;
         this.resetData();
     },
     computed:{
     },
     methods:
     {
        scrollToTop(val) {
            var a = document.getElementById('scrollable-container1')
            if(val) {
                a.scroll({
                    top: 280, 
                    left: 0, 
                    behavior: 'smooth'
                });
            }else{
                a.scroll({
                    top: 400, 
                    left: 0, 
                    behavior: 'smooth'
                });
            }
        },
        editSignatureMethod(imgUrl, bool){
            
            // this.resetAttestation()
            if(imgUrl){
                let specialchar = 'data:image/jpeg;base64';
                this.SignatureDetails.drawImage = '';
                let regexPattern = new RegExp(`[${specialchar}]`, 'g');
                let containsAllChars = specialchar.split('').every(char => imgUrl.match(regexPattern).includes(char));
                if(containsAllChars) {
                    this.SignatureDetails.drawImage = imgUrl
                }else {
                    this.SignatureDetails.drawImage = `data:image/jpeg;base64,${imgUrl}`
                }
                var a = document.getElementById('scrollable-container1')
                if(bool) {
                    a.scroll({
                        top: 240, 
                        left: 0, 
                        behavior: 'smooth'
                    });
                }
            // this.tabType = 'draw'
            this.openEditsignature =  true;
            this.SignatureDetails.editUpload = true
            }
        },
        SignatureEdit(obj){
            let signdata = obj.type == 'Typed' && obj.href ? obj.href.split(',') : obj.type == 'Drawn' && obj.data ? obj.data.split(',') : obj.type =='Uploaded' && obj.image ? obj.image.split(',') : [];
            let base64bitUrl = signdata && signdata.length > 0 ? signdata[signdata.length-1] : ''

                this.SignatureDetails.IsNewSignature = false
                this.SignatureDetails.uploadData = ""
                this.SignatureDetails.image = ""
                this.SignatureDetails.tabType = ""
                this.SignatureDetails.drawImage = ""
                this.SignatureDetails.IsNewSignature = false
                this.SignatureDetails.SignatureURL = ''

                if(obj.type == 'Typed'){
                  
                    this.SignatureDetails.EnableSignature = false
                    this.SignatureDetails.uploadData = obj.href
                    this.SignatureDetails.image = obj.href
                    this.SignatureDetails.SignatureURL = obj.href
                    this.SignatureDetails.tabType = obj.type
                    this.SignatureDetails.Base64Url = base64bitUrl
                    this.SignatureDetails.isDraw = false
                    this.SignatureDetails.metaInformation = obj.metaInformation
                    // this.IsNewSignature = true
                    this.SignatureDetails.IsNewSignature = true
                    this.openEditsignature = false
                }
                if(obj.type == 'Uploaded'){
                   
                    this.SignatureDetails.EnableSignature = false
                    this.SignatureDetails.uploadData = obj.data
                    this.SignatureDetails.image = obj.image
                    this.SignatureDetails.SignatureURL = obj.image
                    this.SignatureDetails.tabType = obj.type
                    this.SignatureDetails.Base64Url = base64bitUrl
                    this.SignatureDetails.isDraw = true
                    // this.IsNewSignature = true
                    this.SignatureDetails.IsNewSignature = true
                    this.openEditsignature = false
                }
            if(obj.type == 'Drawn'){
                this.SignatureDetails.EnableSignature = false
                this.SignatureDetails.uploadData = obj.data
                this.SignatureDetails.image = obj.data
                this.SignatureDetails.SignatureURL = obj.data
                // this.drawImage = obj.drawData
                this.SignatureDetails.tabType = obj.type
                this.SignatureDetails.Base64Url = base64bitUrl
                this.SignatureDetails.isDraw = true
                // this.IsNewSignature = true
                this.SignatureDetails.IsNewSignature = true
                this.openEditsignature = false
                }
            // }
        },
        saveSignature(obj) {
                let signdata = obj.type == 'Typed' && obj.href ? obj.href.split(',') : obj.type == 'Drawn' && obj.data ? obj.data.split(',') : obj.type =='Uploaded' && obj.image ? obj.image.split(',') :  [];
                let base64bitUrl = signdata && signdata.length > 0 ? signdata[signdata.length-1] : ''
                
                this.SignatureDetails.uploadData = ""
                this.SignatureDetails.image = ""
                this.SignatureDetails.tabType = ""
                this.SignatureDetails.drawImage = ""
                this.SignatureDetails.IsNewSignature = false
                
                if(obj.type == 'Typed'){
                    this.showEditSignature = true
                    this.SignatureDetails.EnableSignature = false
                    this.SignatureDetails.uploadData = obj.href
                    this.SignatureDetails.image = obj.href
                    this.SignatureDetails.SignatureURL = obj.href
                    this.SignatureDetails.tabType = obj.type
                    this.SignatureDetails.Base64Url = base64bitUrl
                    this.SignatureDetails.isDraw = false
                    this.SignatureDetails.metaInformation = obj.metaInformation
                    this.SignatureDetails.IsNewSignature = true
                    // this.Section1.SignatureDetails.editUpload =true
                }
                if(obj.type == 'Uploaded'){
                    this.showEditSignature = true
                    this.SignatureDetails.IsNewSignature = true
                    this.SignatureDetails.EnableSignature = false
                    this.SignatureDetails.uploadData = obj.data
                    this.SignatureDetails.image = obj.image
                    this.SignatureDetails.SignatureURL = obj.image
                    this.SignatureDetails.tabType = obj.type
                    this.SignatureDetails.Base64Url = base64bitUrl
                    this.SignatureDetails.isDraw = true
                }
                if(obj.type == 'Drawn'){
                    this.showEditSignature = true
                    this.SignatureDetails.EnableSignature = false
                    this.SignatureDetails.uploadData = obj.data
                    this.SignatureDetails.image = obj.data
                    this.SignatureDetails.SignatureURL = obj.data
                    // this.drawImage = obj.drawData
                    this.SignatureDetails.tabType = obj.type
                    this.SignatureDetails.Base64Url = base64bitUrl
                    this.SignatureDetails.isDraw = true
                    //this.Section1.SignatureDetails.editUpload =true
                    this.SignatureDetails.IsNewSignature = true
                }
                this.counter++
            },
            deleteSiganture(imgUrl){
                // this.resetAttestation()
                this.ShowSignaturePad = false
                if(imgUrl){
                    this.showEditSignature = false
                    this.SignatureDetails.IsNewSignature = true
                    this.SignatureDetails.EnableSignature = true
                    this.SignatureDetails.image = ''
                    this.SignatureDetails.Base64Url = ''
                    this.counter++
                setTimeout(() => {

                    this.ShowSignaturePad = true
                }, 0.1)
                }
            },
       updateValue(value){
          let val = namevalidation.getValidName(value);
          this.EmployerDetails.Name = val
        },
         resetData() {

             // Reset Values
             this.EmployerDetails = {
                Name:'',
                Website:'',
                EmployerAddress:
                    {
                       Address:'',
                       Location:'',
                       City :'',
                       State :'',
                       Suite :'',
                       ZipCode:''
                    },
                EmployerIDNumber :'',
                FullTimeEmployees :'',
                NAICSCode:'',
                OPTHoursPerWeek:'',
                Salary:'',
                SalaryType:'',
                EmploymentStartDate:'',
                Signatoryauthority : {
                    Name: '',
                    Email:'',
                    Title:''
                },
                OtherCompensations:[],
            };

            this.OtherCompensation1 = '';
            this.OtherCompensation2 = '';
            this.OtherCompensation3 = '';
            this.OtherCompensation4 = '';

            // Reset Validations
            this.$v.EmployerDetails.$reset();
            this.isshowValidSign = false
         },
          onChangeSignatoryAuthority(selectedSignatoryAuthorityEmail){
                if(selectedSignatoryAuthorityEmail)
                {
                        var index = this.signatoryauthorityList.data.findIndex(x => x.id == selectedSignatoryAuthorityEmail);
                        if(index != -1) {
                        var selectedAuthority = this.signatoryauthorityList.data[index];
                        this.EmployerDetails.SignatoryAuthority.Name = selectedAuthority.text.replace(/\s?\(you\)\s*$/, '').trim();
                        this.EmployerDetails.SignatoryAuthority.Email = selectedAuthority.id;
                        this.EmployerDetails.SignatoryAuthority.Title = selectedAuthority.title;
                        this.EmployerDetails.SignatoryAuthority.Phone = selectedAuthority.phone;
                        this.EmployerDetails.SignatoryAuthority.Role = selectedAuthority.role;
                        this.EmployerDetails.SignatoryAuthority.Id = selectedAuthority.SAId;
                        }
                }
            },
        copyFromStore() {
            this.resetData();

            // Address
            this.EmployerDetails.EmployerAddress.Address = this._ValueOrEmptyString(this.clonedContent.Employer.Address.Address);
            this.EmployerDetails.EmployerAddress.Location = this._ValueOrEmptyString(this.clonedContent.Employer.Address.Location);
            this.EmployerDetails.EmployerAddress.ZipCode = this._ValueOrEmptyString(this.clonedContent.Employer.Address.ZipCode);

            // Signatory Authority
            this.EmployerDetails.Signatoryauthority.Name = this._ValueOrEmptyString(this.clonedContent.Employer.SignatoryAuthority.Name);
            this.EmployerDetails.Signatoryauthority.Email = this._ValueOrEmptyString(this.clonedContent.Employer.SignatoryAuthority.Email);
            this.EmployerDetails.Signatoryauthority.Title = this._ValueOrEmptyString(this.clonedContent.Employer.SignatoryAuthority.Title);

            this.selectedSignatoryAuthorityEmail = this._ValueOrEmptyString(this.clonedContent.Employer.SignatoryAuthority.Email);

            this.EmployerDetails.Name = this._ValueOrEmptyString(this.clonedContent.Employer.Name);
            this.EmployerDetails.Website = this._ValueOrEmptyString(this.clonedContent.Employer.Website);
            this.EmployerDetails.EmployerIDNumber = this._ValueOrEmptyString(this.clonedContent.Employer.EIN);
            this.EmployerDetails.EmployerAddress.Suite = this._ValueOrEmptyString(this.clonedContent.Employer.Suite);
            this.EmployerDetails.FullTimeEmployees = this._ValueOrEmptyString(this.clonedContent.Employer.FullTimeEmployeesCount);
            this.EmployerDetails.NAICSCode = this._ValueOrEmptyString(this.clonedContent.Employer.NAICSCode);
            this.EmployerDetails.OPTHoursPerWeek = this._ValueOrEmptyString(this.clonedContent.Employer.OPTHours);
            this.EmployerDetails.Salary = this._ValueOrEmptyString(this.clonedContent.Employer.Salary);
            this.EmployerDetails.SalaryType = this._ValueOrEmptyString(this.clonedContent.Employer.SalaryFrequency);
            this.EmployerDetails.EmploymentStartDate = this._ValueOrEmptyString(this.clonedContent.Employee.EmployementStartDate);
            this.SignatureDetails.SignatureURL = this.clonedContent.Employer.SignatureURL
                  this.SignatureDetails.Base64Url = this.clonedContent.Employer.Base64EncodedSignature
                  this.SignatureDetails.EnableSignature = this.clonedContent.Employer.SignatureURL && this.clonedContent.Employer.SignatureURL != '' ? false : true,
                  this.SignatureDetails.tabType = this.clonedContent.Employer.SigningType
                  this.SignatureDetails.image = this.clonedContent.Employer.Base64EncodedSignature
            if(this.clonedContent.Employer.OtherCompensations) {
                this.OtherCompensation1 = this.clonedContent.Employer.OtherCompensations.length > 0 ? this.clonedContent.Employer.OtherCompensations[0] : '';
                this.OtherCompensation2 = this.clonedContent.Employer.OtherCompensations.length > 1 ? this.clonedContent.Employer.OtherCompensations[1] : '';
                this.OtherCompensation3 = this.clonedContent.Employer.OtherCompensations.length > 2 ? this.clonedContent.Employer.OtherCompensations[2] : '';
                this.OtherCompensation4 = this.clonedContent.Employer.OtherCompensations.length > 3 ? this.clonedContent.Employer.OtherCompensations[3] : '';
            } else {
                this.OtherCompensation1 = '';
                this.OtherCompensation2 = '';
                this.OtherCompensation3 = '';
                this.OtherCompensation4 = '';
            }
        },
          copyToStore() {
            // Address
            this.clonedContent.Employer.Address.Address = this.EmployerDetails.EmployerAddress.Address;
            this.clonedContent.Employer.Address.Location = this.EmployerDetails.EmployerAddress.Location;
            this.clonedContent.Employer.Address.City = this.EmployerDetails.EmployerAddress.Location.toString().split(',')[0].trim();
            this.clonedContent.Employer.Address.State = this.EmployerDetails.EmployerAddress.Location.toString().split(',')[1].trim();
            this.clonedContent.Employer.Address.ZipCode = this.EmployerDetails.EmployerAddress.ZipCode;

            //signatoryAuthority
            this.clonedContent.Employer.SignatoryAuthority.Name = this.EmployerDetails.Signatoryauthority.Name;
            this.clonedContent.Employer.SignatoryAuthority.Email = this.EmployerDetails.Signatoryauthority.Email;
            this.clonedContent.Employer.SignatoryAuthority.Title = this.EmployerDetails.Signatoryauthority.Title;

            this.clonedContent.AssignedTraining.SignatoryAuthority.Email = this.EmployerDetails.Signatoryauthority.Email;
            this.clonedContent.AssignedTraining.SignatoryAuthority.Name  = this.EmployerDetails.Signatoryauthority.Name;
            this.clonedContent.AssignedTraining.SignatoryAuthority.Title  = this.EmployerDetails.Signatoryauthority.Title;

            this.clonedContent.Employer.Name = this.EmployerDetails.Name;
            this.clonedContent.Employer.Website = this.EmployerDetails.Website;
            this.clonedContent.Employer.EIN = this.EmployerDetails.EmployerIDNumber;
            this.clonedContent.Employer.Suite = this.EmployerDetails.EmployerAddress.Suite;
            this.clonedContent.Employer.FullTimeEmployeesCount = this.EmployerDetails.FullTimeEmployees;
            this.clonedContent.Employer.NAICSCode = this.EmployerDetails.NAICSCode;
            this.clonedContent.Employer.OPTHours = this.EmployerDetails.OPTHoursPerWeek;
            this.clonedContent.Employer.Salary = this.EmployerDetails.Salary;
            this.clonedContent.Employer.SalaryFrequency = this.EmployerDetails.SalaryType;
            this.clonedContent.Employer.EmploymentStartDate = this.EmployerDetails.EmploymentStartDate;
            this.clonedContent.Employer.OtherCompensations = this.EmployerDetails.OtherCompensations;
            this.clonedContent.Employer.SectionStatus = "Completed";
            this.clonedContent.Employer.SignedDocumentStatus = "";
            this.clonedContent.Employer.SignedDate = this.SignatureDetails.SignedDate
            this.clonedContent.Employer.SignatureURL = this.SignatureDetails.image;
            this.clonedContent.Employer.Base64EncodedSignature = this.SignatureDetails.Base64Url
            this.clonedContent.Employer.SigningType = this.SignatureDetails.tabType
            window.bus.fire('SendI983RefreshSignal', 'fromSignaR');
            // Insert into modified log
            this.$parent.$parent.insertModifiedLogToStore('Employer');
        },
         getZipCode(){
            if(this.EmployerDetails.EmployerAddress.Location != ''){
                ajax.get(`/Account/GetZipCode?location=${this.EmployerDetails.EmployerAddress.Location}`,{},(res) =>{
                    if(res.data.State === true) {
                    this.EmployerDetails.EmployerAddress.ZipCode = res.data.ZipCodeModel.ZipCode
                    }
                    else
                    this.ESSEnableDisable(res)
                })
            }
        },
        _ValueOrEmptyString(obj) {
            return obj || '';
        },
        _OtherCompensations()
        {
                  this.EmployerDetails.OtherCompensations = [];
                  this.EmployerDetails.OtherCompensations.push(this.OtherCompensation1)
                  this.EmployerDetails.OtherCompensations.push(this.OtherCompensation2)
                  this.EmployerDetails.OtherCompensations.push(this.OtherCompensation3)
                  this.EmployerDetails.OtherCompensations.push(this.OtherCompensation4)
        },
         onPreview()
         {
               this._OtherCompensations();
              this.$v.EmployerDetails.$touch();
               if(this.content.SignatureType == 'Electronic'  && this.ShowSignaturePad){
                this.isshowValidSign = this.SignatureDetails.Base64Url ? false : true
               }
              if(this.$v.EmployerDetails.$invalid  == false && !this.isshowValidSign)
              {
                    var address = {
                        address:this.EmployerDetails.EmployerAddress.Address,
                        City: this.EmployerDetails.EmployerAddress.Location.toString().split(',')[0].trim(),
                        State: this.EmployerDetails.EmployerAddress.Location.toString().split(',')[1].trim(),
                        Location:this.EmployerDetails.EmployerAddress.Location,
                        ZipCode:this.EmployerDetails.EmployerAddress.ZipCode,
                    }

                    var signatoryAuthority = {
                        Name:this.EmployerDetails.Signatoryauthority.Name,
                        Email:this.EmployerDetails.Signatoryauthority.Email,
                        Title:this.EmployerDetails.Signatoryauthority.Title == 'HRManager' ? 'HR Manager': this.EmployerDetails.Signatoryauthority.Title,
                    }

                    let employerInfo = {
                    Name:this.EmployerDetails.Name,
                    Website:this.EmployerDetails.Website,
                    Address:address,
                    EIN:this.EmployerDetails.EmployerIDNumber,
                    Suite:this.EmployerDetails.EmployerAddress.Suite,
                    FullTimeEmployeesCount:this.EmployerDetails.FullTimeEmployees,
                    NAICSCode:this.EmployerDetails.NAICSCode,
                    OPTHours:this.EmployerDetails.OPTHoursPerWeek,
                    SignatoryAuthority:signatoryAuthority,
                    Salary:this.EmployerDetails.Salary,
                    SalaryFrequency:this.EmployerDetails.SalaryType,
                    EmploymentStartDate:this.EmployerDetails.EmploymentStartDate,
                    OtherCompensations:this.EmployerDetails.OtherCompensations,
                    SignedDate: this.SignatureDetails.SignedDate == 'Electronic' ? this.SignatureDetails.SignedDate : moment(new Date()).format('MM/DD/YYYY'),
                    Base64EncodedSignature: this.SignatureDetails.Base64Url,
                    SigningType:this.SignatureDetails.tabType
                }
                this.EmployerObject={
                    Employee: {
                        Name: this.clonedContent.Employee.Name
                    },
                    Employer:employerInfo,
                    GeoLocation: this.SignatureDetails.IsNewSignature ? 'SignatureSigned' : null,
                    UserAgent:navigator.userAgent
                }

                  if(this.isupdate) {
                   this.updateEmployerDetails();
                  } else {
                      this.$loading({'loadingText': 'Previewing Employer Info...'});
                     this.$parent.previewDocument("Employer", this.EmployerObject)
                  }
             }
         },
         updateEmployerDetails()
         {
                    let loadingText = 'Initiating...';
                    if(this.isupdate) {
                        loadingText = 'Updating....';
                    }
                    this.$loading({loadingText: loadingText});
                    ajax.put(`/I983/${this.content.Id}/UpdateEmployerDetails`,this.EmployerObject, (res) => {
                        if(res.data.State == true) {
                            let msg = 'Employer Information initiated Successfully';
                            if(this.isupdate) { // when update
                                msg = 'Employer Information updated Successfully';
                            }
                            this.$message({
                                type: 'success',
                                message: msg
                            });
                            this.employerPopup = false;
                            this.$loading({}).close();
                            this.copyToStore();

                        }else if(res.data.State == false){
                            this.employerPopup = false;
                            this.$loading({}).close();
                            this.$message({
                                type: 'error',
                                message: res.data.Message
                            });
                        }
                    });
         },
         getSignatoryauthorityList()
         {   this.showSignatoryauthorityList = false
              ajax.get(`/I983/SignatoryList?employeeId=${this.content.Employee.EmployeeId}`,{},(res)=>{
                this.signatoryauthorityList.data = __.map(res.data.SignatoryModelList, (t) => {
                    var name = t.BasicModel.Name;
                        if(t.Email == this.loggedInUserObj.email)
                        {
                          name = t.BasicModel.Name + " (you)";
                        }
                    return { 'id': t.Email, 'text': name, "title":t.Designation ,"Role":t.Role,"SAId":t.Id,"phone":t.Phone }
                })
                this.showSignatoryauthorityList = true
            })
         },
        getCurrentOrganizationDetails()
        {
            this.$loading({loadingText: 'Please wait...'});
            ajax.get(`/Organization/GetCurrentUserOrganizationDetails`, {}, (res) => {
                this.$loading({}).close();
                if(res.data.State == true) {
                    this.EmployerDetails.EmployerAddress.Address = this._ValueOrEmptyString(res.data.Organizationmodels.HeadOfficeAddress.Address1);
                    if(res.data.Organizationmodels.HeadOfficeAddress.City != null && res.data.Organizationmodels.HeadOfficeAddress.State != null && res.data.Organizationmodels.HeadOfficeAddress.City != '' && res.data.Organizationmodels.HeadOfficeAddress.State != ''){
                      this.EmployerDetails.EmployerAddress.Location = res.data.Organizationmodels.HeadOfficeAddress.City + "," + res.data.Organizationmodels.HeadOfficeAddress.State;
                    }
                    this.EmployerDetails.EmployerAddress.ZipCode = this._ValueOrEmptyString(res.data.Organizationmodels.HeadOfficeAddress.Zip);
                    if(res.data.Organizationmodels.HeadOfficeAddress.IsSuite == true){
                      this.EmployerDetails.EmployerAddress.Suite = this._ValueOrEmptyString(res.data.Organizationmodels.HeadOfficeAddress.AptNumber);
                    }
                    this.EmployerDetails.Name = this._ValueOrEmptyString(res.data.Organizationmodels.OrganizationName);
                    this.EmployerDetails.Website = this._ValueOrEmptyString(res.data.Organizationmodels.Website);
                    this.EmployerDetails.NAICSCode = this._ValueOrEmptyString( res.data.Organizationmodels.NaicsCode);
                }
                else
                    this.ESSEnableDisable(res)
            })
        },
     },
     validations(){

            return{
                SignatureDetails : {
                           Base64Url: {
                               requiredIf: requiredIf((a) => {
                                   if(this.content.SignatureType == 'Electronic') {
                                       return true
                                   }else{
                                       return false
                                   }
                               })
                            }
                           },
                           tabType: {
                           requiredIf: requiredIf((a) => {
                               if(this.content.SignatureType == 'Electronic') {
                                   return true
                               }else{
                                   return false
                               }
                           })
                       },
                  
                "EmployerDetails":
                {
                    Name:
                     {
                          required,
                          maxLength: maxLength(150),
                          letterCount
                     },
                    Website:{
                          required,
                          url
                     },
                     SalaryType:{
                          required
                     },
                    "EmployerAddress":
                        {
                               Address:{
                               required
                            },
                                Location:{
                                required
                            },
                                Suite :{
                                required
                            },
                                ZipCode:{
                                required
                            },
                        },
                    EmployerIDNumber :{
                          required
                     },
                    FullTimeEmployees :{
                          required
                     },
                    NAICSCode:{
                          required
                     },
                    OPTHoursPerWeek:{
                          required,
                          validOPTHoursPerWeek
                     },
                    Salary:{
                          required,
                            minValue: minValue(1)
                     },
                    SalaryType:{
                          required
                     },
                    EmploymentStartDate:{
                          required
                     },                
                 }
            }
     }

}
</script>
<style>

.title-content {
    color: #4a90e2;
    font-size: 14px;
    padding-left: 10px;
}
    .validation-star{
        color: #F31D1D;
    }
     .custom-sign-div_inline_style2 {
        display: inline-block;
        margin-left: 15px;
        width: 20%;
    }
    .delete-sign-icon {
        height: 35px;
        width: 35px; 
        margin-bottom: -65px;
        cursor: pointer;
    }
    .custom-sign-div {
        flex: 1 1 auto;
        min-height: 1px;
        /* padding: 1.5rem; */
        background: #FCFCFF;
        text-align: center;
        border: 1px solid rgba(219,219,232,0.50);
        width: 650px;
        height:139px !important;
        padding: 20px 15px;
    }
    .custom-sign-div_inline_style1{
        display:inline-block;
        height:100px;
        width:49%;
        float:left; 
    }
</style>




// WEBPACK FOOTER //
// src/components/ESSProfile/FormI983/InitiateEmployerInfo.vue